import React from "react";
import DashboardPage from "./components/Dashboard";
import LoginLogoutButtons from "./components/LoginLogoutButtons";
import "./style.css";

import {
	BrowserRouter,
	Routes,
	Route,
	Navigate,
	useNavigate,
} from "react-router-dom";
import {
	useIsAuthenticated,
	useMsal,
	MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { InteractionType } from "@azure/msal-browser";

// --- Pages ---
function HomePage() {
	const isAuthenticated = useIsAuthenticated();
	const navigate = useNavigate();

	React.useEffect(() => {
		if (isAuthenticated) {
			navigate("/dashboard", { replace: true }); // auto redirect if logged in
		}
	}, [isAuthenticated, navigate]);

	return (
		<div class="mainContainer">
			<div className="home-container">
				<h1>Welcome to Dedupe v2</h1>
				<p>
					Dedupe v2 helps you efficiently match and clean your leads with
					advanced AI-powered deduplication tools. Upload your CSV files and get
					results instantly.
				</p>
				<LoginLogoutButtons />
			</div>
		</div>
	);
}

function NotAllowed() {
	return <h2>🚫 Not Allowed</h2>;
}

// --- Auth Wrapper ---
function AuthenticatedRoute({ children }) {
	const isAuthenticated = useIsAuthenticated();
	return isAuthenticated ? children : <Navigate to="/not-allowed" />;
}

// --- Main App ---
function App() {
	return (
		<BrowserRouter>
			<div>
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/not-allowed" element={<NotAllowed />} />

					{/* Catch all dashboard sub-routes */}
					<Route
						path="/dashboard/*"
						element={
							<MsalAuthenticationTemplate
								interactionType={InteractionType.Redirect}
								authenticationRequest={loginRequest}>
								<AuthenticatedRoute>
									<DashboardPage />
								</AuthenticatedRoute>
							</MsalAuthenticationTemplate>
						}
					/>

					{/* Redirect any unmatched route to / */}
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</div>
		</BrowserRouter>
	);
}

export default App;
